@use 'sass:math';
@use '../../scss/utility';
@use '../value-slider/value-slider-vars';

$circle-size: utility.wb-pixel-to-rem(24px);
$update-transition-duration: 0.05s;

:host {
  @include value-slider-vars.wb-value-slider-vars;
  display: block;
  width: 100%;
}

.inner {
  width: 100%;
  position: relative;
  height: $circle-size;
}

.label {
  color: var(--value-slider-text-color);
  display: block;
  padding-inline-start: math.div($circle-size, 2);
  margin-block-end: utility.wb-pixel-to-rem(4px);
  cursor: pointer;
}

.dots {
  display: flex;
  justify-content: space-between;
}

.dot {
  background-color: var(--value-slider-scale-indicator-color);
  width: utility.wb-pixel-to-rem(4px);
  height: utility.wb-pixel-to-rem(4px);
  border-radius: var(--wb-radius-s);
  z-index: 1;
}

input {
  position: absolute;
  inset-block-end: 0;
  appearance: none;
  height: $circle-size;
  background: transparent;
  border: 0;
  outline: 0;
  margin: 0;
  padding: 0;
  cursor: pointer;
  opacity: 0;
  -webkit-tap-highlight-color: transparent;

  &.active,
  &:focus {
    z-index: 1;
  }

  &::-webkit-slider-thumb {
    appearance: none;
    width: $circle-size;
    height: $circle-size;
  }

  &::-moz-range-thumb {
    appearance: none;
    width: $circle-size;
    height: $circle-size;
  }

  // note: keeping this for future debugging
  // opacity: 0.25;

  // &[name='start'] {
  //   background: #f00;
  // }

  // &[name='end'] {
  //   background: #0f0;
  // }

  // &::-webkit-slider-thumb {
  //   background: #000;
  // }

  // &::-moz-range-thumb {
  //   background: #000;
  // }
}

/* stylelint-disable selector-id-pattern */

#start {
  inset-inline-start: 0;
}

#end {
  inset-inline-end: 0;
}

#start:not(:disabled):hover ~ .overlay .indicator.is-start,
#end:not(:disabled):hover ~ .overlay .indicator.is-end {
  @include value-slider-vars.wb-value-slider-hover-vars;
}

#start:not(:disabled):focus ~ .overlay .indicator.is-start,
#end:not(:disabled):focus ~ .overlay .indicator.is-end,
#start:not(:disabled):focus-visible ~ .overlay .indicator.is-start,
#end:not(:disabled):focus-visible ~ .overlay .indicator.is-end {
  @include value-slider-vars.wb-value-slider-focus-vars;

  border: var(--value-slider-indicator-border-weight) solid var(--value-slider-indicator-border-ring-color);
}

#start:not(:disabled):active ~ .overlay .indicator.is-start,
#start:not(:disabled).active ~ .overlay .indicator.is-start,
#end:not(:disabled):active ~ .overlay .indicator.is-end,
#end:not(:disabled).active ~ .overlay .indicator.is-end,
#start:not(:disabled):focus-visible ~ .overlay .indicator.is-start,
#end:not(:disabled):focus-visible ~ .overlay .indicator.is-end {
  @include value-slider-vars.wb-value-slider-active-vars;

  box-shadow: initial;
}

.overlay {
  position: absolute;
  pointer-events: none;
  background: var(--value-slider-bar-empty-color);
  border-radius: var(--wb-radius-s);
  height: utility.wb-pixel-to-rem(4px);
  inset-inline: math.div($circle-size, 2);
  inset-block-start: 50%;
  transform: translateY(-50%);
}

.indicator {
  position: absolute;
  box-sizing: border-box;
  width: $circle-size;
  height: $circle-size;
  background: var(--value-slider-indicator-background-color);
  border-radius: var(--wb-radius-full);
  transform: translate3d(-50%, -10px, 0);
  z-index: 2;
  transition:
    left $update-transition-duration var(--wb-move),
    right $update-transition-duration var(--wb-move);
}

.progress-line {
  position: absolute;
  inset-inline-start: 0;
  height: utility.wb-pixel-to-rem(4px);
  background: var(--value-slider-bar-filled-color);
  border-radius: var(--wb-radius-s);
  transition:
    left $update-transition-duration var(--wb-move),
    right $update-transition-duration var(--wb-move);
}

.highlight-area {
  position: absolute;
  inset-inline-start: 0;
  height: utility.wb-pixel-to-rem(4px);
  background: var(--value-slider-bar-range-color);
  border-radius: var(--wb-radius-s);
  mix-blend-mode: multiply;
}

.scale {
  display: flex;
  justify-content: space-between;
  padding: 0 math.div($circle-size, 2);
  height: utility.wb-pixel-to-rem(28px);
  align-items: flex-end;
}

.scale-item {
  position: relative;

  .wb-text {
    position: absolute;
    inset-block-end: 0;
    inset-inline-start: 0;
    transform: translateX(-50%);
  }

  &:first-child .wb-text {
    transform: translateX(0);
  }

  &:last-child .wb-text {
    transform: translateX(-100%);
  }
}

:host([disabled]) {
  .inner {
    opacity: var(--value-slider-opacity-disabled);
  }

  input {
    cursor: not-allowed;
  }
}

:host([is-rtl]) {
  .indicator {
    transform: translate3d(50%, -10px, 0);
  }
  .scale-item {
    .wb-text {
      transform: translateX(50%);
    }
    &:last-child .wb-text {
      transform: translateX(100%);
    }
  }
}
